export const LISTINGS_TYPE_QUERY_PARAM = 'listingsType';
